export default "__VITE_ASSET__Ll$nduZI__"